export default function Divider() {
  return <div className="modal-divider" />;
}
